const invariant = (condition, message = "An invariant was violated!") => {
  if (!condition) {
    throw new Error(message);
  }
};

export default invariant;
